import { ActionType, createReducer } from 'typesafe-actions';
import { clearDoubleBetAction, doubleBetSuccessAction, resetDoubleBetAction } from './actions';
import { IBetDoubleState } from './types';

export const betDoubleState: IBetDoubleState = {
  isUsed: false,
};

const actions = {
  doubleBetSuccessAction,
  clearDoubleBetAction,
  resetDoubleBetAction,
};

export const betDoubleReducer = createReducer<IBetDoubleState, ActionType<typeof actions>>(
  betDoubleState,
)
  .handleAction(doubleBetSuccessAction, (state) => ({
    ...state,
    isUsed: true,
  }))
  .handleAction(clearDoubleBetAction, (state) => ({
    ...state,
    isUsed: false,
  }))
  .handleAction(resetDoubleBetAction, (state) => ({
    ...state,
    isUsed: false,
  }));
